// src/services/LabTestApi/symptomsApi.js

import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL;

export const fetchSymptoms = async () => {
  try {
    const res = await axios.get(`${API_BASE}Lab/GetAllSymptoms`);
    
    console.log("📦 API Response:", res.data);
    
    // ✅ Handle different response structures
    let symptoms = [];
    
    if (Array.isArray(res.data)) {
      symptoms = res.data;
    } else if (res.data?.data && Array.isArray(res.data.data)) {
      symptoms = res.data.data;
    } else if (res.data?.result && Array.isArray(res.data.result)) {
      symptoms = res.data.result;
    } else {
      symptoms = [];
    }
    
    console.log("📊 Symptoms extracted:", symptoms.length);
    return symptoms;
    
  } catch (error) {
    console.error("❌ Error fetching symptoms:", error);
    throw new Error("Failed to load symptoms");
  }
};